import learnenglishMutations from "./learnenglishMutations";
import learnenglishGetters from "./learnenglishGetters";
import learnlishActions from "./learnlishActions";
export default {
    state:{
        //使用方式是：$store.state.a.testNuma
        //UserLogin组件里使用的账号值
        info:{
            username:null,
            autoplay:false,
            newWordNum:null,
            // ukus:false,

        },
        //存放登录账号，多余的
        username:'',
        //双向绑定第一查词输入框
        searchWord: '',
        //查询的单个单词信息
        words: {
            'word':'',
            'cixing': '',
            'yinbiao': '',
            'fanyi': '',
            'yinjie': '',
            'ciyuan': '',
        },

        //获取的新词的数量，和list
        newWordListNum:10,
        newWordList:[{
            word:'BULLJ',
            yinjie:'BULL_J',
            yinbiao:'bullj',
            fanyi:'公牛J'
        }],
        //获取复习单词
        reviewWordLIst:[],
        recoverWordLIst:[],
        planWordLIst:[],
        allPlanWordLIst:[],

        //输入框存放值的list
        inputWordList:[],

        //获取当前item的index,以期能在同样的位置往inputWordList中存入输入值，
        // 来判断是否输入正确，有个问题，切换背默词时，会发生错序
        currentCardItemIndex:0,

        //当前的单词，用来指定音频的播放来源
        currentCardItemWord:'bull',

        //切换背词和默词list的开关，默认false是背词
        wordListSwitch:false,

        //控制显示界面组件的多选框
        showModuleList:['查词'],

        //控制音频是否循环播放的开关
        isAudioLoopPlay:false,
        //切换英式和美式发音的开关
        isUk:true,
        //用来控制打卡后更新新词list的index会置零的问题
        backCardWordItemNum:0,
        //用来判断控制打卡后更新新词list的index会置零的问题,也可以直接用backCardWordItemNum>0来替代
        isBackCardWordItem:false,
    },
    mutations:learnenglishMutations,
    actions:learnlishActions,
    getters:learnenglishGetters
}